import React, {Component} from 'react';
import { Row, Col } from 'antd';
import { FormattedMessage } from 'react-intl';

import antwerpen from '../../assets/images/antwerpen.png'
import mechelen from '../../assets/images/mechelen.png'
import leuven from '../../assets/images/leuven.png'
import gent from '../../assets/images/gent.png'
import brugge from '../../assets/images/brugge.png'
import flanders from '../../assets/images/flanders.png'

class CitySelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  
  onCitySelection = city => {
    const { selectedCity, onCitySelection } = this.props;
    onCitySelection(selectedCity === city ? 'all' : city);
  }
  
  render() {
    const { selectedCity } = this.props
    return (
      <div>
      <Row type="flex" gutter={8} style={{ fontFamily: 'Flanders Art Sans Bold' }}>
        <Col span={4} onClick={() => this.onCitySelection('all')}>
          <Row style={{ cursor: "pointer", backgroundColor: selectedCity === 'all' ? '#ffe615' : '#ffffffee', borderRadius: 8, padding: 10 }}>
            <img src={flanders} style={{ width: '80%' }} alt='all'/> 
            <div style={{ textTransform: 'uppercase'}}><FormattedMessage id="city.all" /></div>
          </Row>
        </Col>
        <Col span={4} onClick={() => this.onCitySelection('Antwerpen')}>
          <Row style={{ cursor: "pointer", backgroundColor: selectedCity === 'Antwerpen' ? '#ffe615' : '#ffffffee', borderRadius: 8, padding: 10 }}>
            <img src={antwerpen} style={{ width: '80%' }} alt='all'/> 
            <div style={{ textTransform: 'uppercase'}}><FormattedMessage id="city.antwerpen" /></div>
          </Row>
        </Col>
        <Col span={4} onClick={() => this.onCitySelection('Mechelen')}>
          <Row style={{ cursor: "pointer", backgroundColor: selectedCity === 'Mechelen' ? '#ffe615' : '#ffffffee', borderRadius: 8, padding: 10 }}>
            <img src={mechelen} style={{ width: '80%' }} alt='mechelen'/> 
            <div style={{ textTransform: 'uppercase'}}><FormattedMessage id="city.mechelen" /></div>
          </Row>
        </Col>
        <Col span={4} onClick={() => this.onCitySelection('Leuven')}>
          <Row style={{ cursor: "pointer", backgroundColor: selectedCity === 'Leuven' ? '#ffe615' : '#ffffffee', borderRadius: 8, padding: 10 }}>
            <img src={leuven} style={{ width: '80%' }} alt='leuven'/> 
            <div style={{ textTransform: 'uppercase'}}><FormattedMessage id="city.leuven" /></div>
          </Row>
        </Col>
        <Col span={4} onClick={() => this.onCitySelection('Gent')}>
          <Row style={{ cursor: "pointer", backgroundColor: selectedCity === 'Gent' ? '#ffe615' : '#ffffffee', borderRadius: 8, padding: 10 }}>
            <img src={gent} style={{ width: '80%' }} alt='gent'/> 
            <div style={{ textTransform: 'uppercase'}}><FormattedMessage id="city.gent" /></div>
          </Row>
        </Col>
        <Col span={4} onClick={() => this.onCitySelection('Brugge')}>
          <Row style={{ cursor: "pointer", backgroundColor: selectedCity === 'Brugge' ? '#ffe615' : '#ffffffee', borderRadius: 8, padding: 10 }}>
            <img src={brugge} style={{ width: '80%' }} alt='Brugge'/> 
            <div style={{ textTransform: 'uppercase'}}><FormattedMessage id="city.brugge" /></div>
          </Row>
        </Col>
      </Row>
      {/*<Tabs defaultActiveKey={selectedCity} tabBarGutter={0} style={{ textAlign: 'center', fontFamily: 'Flanders Art Sans' }} onChange={this.onCitySelection}>
      <Tabs.TabPane tab={
        <Row>
        <img src={flanders} style={{ width: 40 }} alt='all'/> <div>All</div>
        </Row>
      } key="all">
      </Tabs.TabPane>
      <Tabs.TabPane tab={
        <Row>
        <img src={antwerpen} style={{ width: 40 }} alt='all'/> <div>Antwerpen</div>
        </Row>
      } key="Antwerpen">
      </Tabs.TabPane>
      <Tabs.TabPane tab={
        <Row>
        <img src={mechelen} style={{ width: 40 }} alt='all'/> <div>Mechelen</div>
        </Row>
      } key="Mechelen">
      </Tabs.TabPane>
      <Tabs.TabPane tab={
        <Row>
        <img src={leuven} style={{ width: 40 }} alt='all'/> <div>Leuven</div>
        </Row>
      } key="Leuven">
      </Tabs.TabPane>
      <Tabs.TabPane tab={
        <Row>
        <img src={gent} style={{ width: 40 }} alt='all'/> <div>Gent</div>
        </Row>
      } key="Gent">
      </Tabs.TabPane>
      <Tabs.TabPane tab={
        <Row>
        <img src={brugge} style={{ width: 40 }} alt='all'/> <div>Brugge</div>
        </Row>
      } key="Brugge">
      </Tabs.TabPane>
    </Tabs>*/}
      {/*<Row type="flex" gutter={16} justify='space-between' >
      <Col span={4} style={{ boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)', paddingTop: 4, cursor: 'pointer', backgroundColor: selectedCity === 'all' ? '#fff200' : 'white' }} onClick={() => this.onCitySelection('all')}>
      <img src={flanders} style={{ width: '100%' }} alt='all'/>
      <h3>All Cities</h3>
      </Col>
      <Col span={4} style={{ boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)', paddingTop: 4, cursor: 'pointer', backgroundColor: selectedCity === 'Antwerpen' ? '#fff200' : 'white' }} onClick={() => this.onCitySelection('Antwerpen')}>
      <img src={antwerpen} style={{ width: '100%' }} alt='Antwerpen'/>
      <h3>Antwerpen</h3>
      </Col>
      <Col span={4} style={{ boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)', paddingTop: 4, cursor: 'pointer', backgroundColor: selectedCity === 'Mechelen' ? '#fff200' : 'white' }} onClick={() => this.onCitySelection('Mechelen')}>
      <img src={mechelen} style={{ width: '100%' }} alt='Mechelen'/>
      <h3>Mechelen</h3>
      </Col>
      <Col span={4} style={{ boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)', paddingTop: 4, cursor: 'pointer', backgroundColor: selectedCity === 'Leuven' ? '#fff200' : 'white' }} onClick={() => this.onCitySelection('Leuven')}>
      <img src={leuven} style={{ width: '100%' }} alt='Leuven'/>
      <h3>Leuven</h3>
      </Col>
      <Col span={4} style={{ boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)', paddingTop: 4, cursor: 'pointer', backgroundColor: selectedCity === 'Gent' ? '#fff200' : 'white' }} onClick={() => this.onCitySelection('Gent')}>
      <img src={gent} style={{ width: '100%' }} alt='Gent'/>
      <h3>Gent</h3>
      </Col>
      <Col span={4} style={{ boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)', paddingTop: 4, cursor: 'pointer', backgroundColor: selectedCity === 'Brugge' ? '#fff200' : 'white' }} onClick={() => this.onCitySelection('Brugge')}>
      <img src={brugge} style={{ width: '100%' }} alt='Bruges'/>
      <h3>Brugge</h3>
      </Col>
    </Row>*/}
    </div>
    )
  }
}

export default CitySelector